// DTOs — costo unitario de insumos de tienda (sticker, termo) con vigencia (WS-5).
//
//   - GET  /api/coordinador/configuracion/costo-insumo  — vigentes + histórico
//   - POST /api/coordinador/configuracion/costo-insumo  — fijar nueva vigencia
//
// Tenant-global (planta_id NULL) con fallback; gateado por `puede_ver_costos`.
// Editar crea una nueva vigencia, nunca pisa la historia.
import { z } from 'zod';
export const costoInsumoTipoSchema = z.enum(['sticker', 'termo']);
/** Valor vigente de un insumo. */
export const costoInsumoVigenteSchema = z.object({
    tipo: costoInsumoTipoSchema,
    valor_unitario_cop: z.number(),
    vigente_desde: z.string(),
});
/** Una fila del histórico (tabla costos_insumo). */
export const costoInsumoHistoricoItemSchema = z.object({
    id: z.string().uuid(),
    tipo: costoInsumoTipoSchema,
    valor_unitario_cop: z.number(),
    vigente_desde: z.string(),
    vigente_hasta: z.string().nullable(),
    registrado_por_nombre: z.string().nullable(),
});
export const costoInsumoResponseSchema = z.object({
    /** Valor vigente por tipo (0–2 ítems: sticker y/o termo). */
    vigentes: z.array(costoInsumoVigenteSchema),
    /** Histórico descendente por vigencia (todos los tipos). */
    historico: z.array(costoInsumoHistoricoItemSchema),
});
/**
 * Payload para fijar un nuevo costo de insumo. Crea una NUEVA vigencia (cierra
 * la abierta de ese tipo/planta y abre la nueva). `planta_id` opcional: si se
 * omite, aplica tenant-wide.
 */
export const costoInsumoUpsertSchema = z.object({
    tipo: costoInsumoTipoSchema,
    valor_unitario_cop: z.number().positive().max(99999999999),
    vigente_desde: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Fecha YYYY-MM-DD'),
    planta_id: z.string().uuid().optional(),
});
//# sourceMappingURL=coordinador_costo_insumo.js.map